export default __webpack_public_path__ + "static/bliklogoWhite-32dcfa15e7039cc90bb4b888a921772b.png";